import { atom } from 'recoil'

export const trackerBoardRefetchTrigger = atom({
  key: 'trackerBoardRefetchTrigger',
  default: 0,
})

export const scheduleBoardRefetchTrigger = atom({
  key: 'scheduleBoardRefetchTrigger',
  default: 0,
})

/** 개인 스케줄 페이지(/standalone-schedule/:team/:id)에서 보는 사용자 ID. null이면 로그인 유저 기준 */
export const standaloneScheduleViewUserId = atom({
  key: 'standaloneScheduleViewUserId',
  default: null,
})
